module.exports = "<div class=\"layout-container\" [ngClass]=\"layout()\">\r\n    <!-- top navbar-->\r\n    <app-header></app-header>\r\n    <!-- sidebar-->\r\n    <app-sidebar></app-sidebar>\r\n    <div (click)=\"closeSidebar()\" class=\"sidebar-layout-obfuscator\"></div>\r\n    <!-- Main section-->\r\n    <main class=\"main-container\">\r\n        <!-- Page content-->\r\n        <section>\r\n            <router-outlet></router-outlet>\r\n        </section>\r\n        <!-- Page footer-->\r\n        <footer><span>2017 - Inger.</span></footer>\r\n    </main>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 1239
// module chunks = 13